export class User {
  constructor(
    public email: string,
    public id: string,
    public memberId: number,
    public isLeader: boolean,
    public firstName: string,
    public lastName: string,
    public phoneNumber: string,
    public roles: string[],
    public _token: string,
    public _tokenExpiration: Date,
    public language: string
  ) {}

  get token() {
    if (!this._tokenExpiration || new Date() > this._tokenExpiration)
      return null;
    return this._token;
  }
}
